'use client';

import { useRouter } from 'next/navigation';
import { IconArrow } from 'app/components/sprites';
import classNames from 'classnames';

interface IProps {
  theme?: 'trans' | 'sand' | 'brown' | 'green';
  label?: string;
}

export default function ButtonBack({
  theme = 'trans',
  label = 'Назад'
}: IProps) {
  const router = useRouter();

  return (
    <button
      type="button"
      className={classNames('button button-default group', {
        'button-trans': theme === 'trans',
        'button-sand': theme === 'sand',
        'button-brown': theme === 'brown',
        'button-green': theme === 'green'
      })}
      onClick={() => router.back()}
    >
      <span className="flex items-center gap-2">
        <span className="rotate-180">
          <IconArrow className="fill-none stroke-current w-[8px] h-[12px] group-hover:translate-x-px transiton-[transform,colors] duration-300" />
        </span>
        <span>{label}</span>
      </span>
    </button>
  );
}
